// extracted by mini-css-extract-plugin
export var disabled = "_1i-a";
export var hierarchyLinkGray = "_1i-4";
export var hierarchyLinkUnderline = "_1i-3";
export var hierarchyPrimary = "_1i-0";
export var hierarchySecondary = "_1i-1";
export var hierarchyTertiary = "_1i-2";
export var pressed = "_1i-6";
export var themeAction = "_1i-5";
export var themeDestructive = "_1i-8";
export var themeNormal = "_1i-7";
export var themeSuccess = "_1i-9";